<template>
  <v-card>
    <v-layout column>
      <v-toolbar card dense light flat >
        <v-flex>
          <v-layout row>
            <v-icon light v-html="cxt.getTitleIcon()"></v-icon>
          </v-layout>
          <v-flex v-if="!getIsMobile" pl-3 class="caption" v-html="formatCountTitle"></v-flex>
          <v-flex v-if="getIsMobile" class="caption" v-html="formatCountTitle"></v-flex>
        </v-flex>
          <v-layout v-show="cxt.isFilterMode() && cxt.isSelectMode()" style="overflow:hidden" justify-end>
          </v-layout>
          <v-flex v-show="cxt.isFilterMode()" sm4 xs4>
            <v-text-field
              autofocus
              label="Фильтр"
              v-show="cxt.isFilterMode()"
              :value="cxt.filterString"
              v-on:input="setRequest"
              solo flat
            ></v-text-field>
          </v-flex>
      </v-toolbar>
      <v-card-scroll flat :height="calcDialogScroll(48+48+52)">
      <v-list three-line dense>
        <template v-for="item in this.filteredItems">
          <v-subheader v-if="item.header" v-text="item.header"></v-subheader>
          <v-divider v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
          <v-list-tile v-else v-bind:key="item.inn" @click="select(item.inn)">
             <v-list-tile-content>
              <div v-html="renderReference(item, '_blank')"></div>
              <v-flex pl-2>
                <div>
                  <span v-html="formatDescription(item)"></span>
                </div>
              </v-flex>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon v-if="radio" v-show="cxt.check(getItemKey(item))">radio_button_checked</v-icon>
              <v-icon v-if="radio" v-show="cxt.uncheck(getItemKey(item))">radio_button_unchecked</v-icon>
              <v-icon v-if="!radio" v-show="cxt.check(getItemKey(item))">check_box</v-icon>
              <v-icon v-if="!radio" v-show="cxt.uncheck(getItemKey(item))">check_box_outline_blank</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>
    </v-card-scroll>
  </v-layout>
  </v-card>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'
  import formats from '../../api/formats'
  import server from '../../api/server'
  import classes from '../../api/classes'
  import vCardScroll from '../common/CardScroll'

  export default {
    name: 'v-human-selector-tab',
    components: {vCardScroll},
    data: () => ({
      itemId: null,
      cxt: null,
      humans: [],
      isLoading: false
    }),
    created () {
      var cxt = new classes.MultiSelectContext(() => {
        return this.filteredItems.map(item => this.getItemKey(item))
      })
      cxt.filterMode = true
      cxt.mode = classes.modes.SELECT
      this.cxt = cxt
    },
    mounted () {
      this.cxt.filterString = this.query
      this.itemId = this.queryCxt
      this.fetchItems()
    },
    watch: {
      queryCxt (newVal) {
        this.itemId = newVal
        this.fetchItems()
      },
      query () {
        this.request = this.query
      },
      selected (newVal, oldVal) {
        this.cxt.setSelected(newVal)
      },
      methodsQueue () {
        this.processMethodsQueue()
      }
    },
    props: {
      fullscreen: {
        type: Boolean,
        default: false
      },
      radio: {
        type: Boolean,
        default: false
      },
      queryCxt: {
        type: String,
        default: null
      },
      query: {
        type: String,
        default: null
      },
      selected: {
        type: Array,
        default: []
      },
      methodsQueue: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapGetters({
        renderReference: 'renderReference',
        getIsMobile: 'getIsMobile',
        renderInnflHtml: 'renderInnflHtml',
        calcDialogScroll: 'calcDialogScroll',
        renderShare: 'renderShare'
      }),
      formatCountTitle () {
        var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано '
        if (this.cxt.isSelectMode()) {
          return this.getSearchTotal > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getSearchTotal + ' первых' : ''
        }
      },
      title () {
        return 'Выберите физическое лицо'
      },
      items () {
        return this.humans
      },
      orderedItems () {
        return this.items.sort((a, b) => formats.compareString(a.caption, b.caption))
      },
      filteredItems () {
        const getSearchString = (item) => {
          return ''
            .concat(
              item.inn,
              item.caption)
        }
        var filter = (!this.cxt.isFilterMode()) || (this.cxt.filterString === null) || (this.cxt.filterString.length < 3) ? null : this.cxt.filterString.toUpperCase()
        if (!filter) {
          return this.orderedItems
        }
        return this.orderedItems.filter(item => {
          return getSearchString(item).toUpperCase().includes(filter)
        })
      },
      isSearching () {
        return this.isLoading
      },
      getSearchTotal () {
        return this.humans && this.humans.length || 0
      }
    },
    methods: {
      processMethodsQueue () {
        if (!this.methodsQueue) return
        let len = this.methodsQueue.length
        for (let i = 0; i < len; i++) {
          let method = this.methodsQueue.shift()
          if (this[method.name]) {
            this[method.name](method.params)
          }
        }
      },
      checkAll () {
        this.cxt.checkAll()
        this.$emit('input', this.cxt.selected())
      },
      select (uid) {
        if (this.cxt.uncheck('inn:' + uid)) {
          if (this.radio) {
            this.cxt.clear()
          }
        }
        this.cxt.select('inn:' + uid)
        this.$emit('input', this.cxt.selected())
      },
      setRequest (v) {
        this.cxt.filterString = v
      },
      getItems (id, cb) {
        const cbError = (e) => {
          this.isLoading = false
          this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении списка физических лиц компании '})
        }
        let companyRefCode = id
        if (!formats.isRefCode(companyRefCode)) {
          this.$store.commit('setErrorStatus', {error: `Неверный код компании [${companyRefCode}] `, context: 'Ошибка клиента при получении списка физических лиц компании '})
        }
        server.openApiGet(
          '/openapi/companies/' + formats.splitRefCode(companyRefCode).code + '/humans',
          cb,
          cbError)
      },
      fetchItems () {
        this.isLoading = true
        this.humans = []
        this.getItems(this.itemId, (data) => {
          this.humans = data
          this.isLoading = false
        })
      },
      getItemKey (item) {
        return 'inn:' + item.inn
      },
      formatPercent (item) {
        var share = formats.getValue(item, ['holderShares', 0])
        return this.renderShare(share)
      },
      formatDescription (item) {
        var result = '.'
        if (item.holderName) {
          result = `Участник ${this.formatPercent(item)} ${item.holderDetails ? item.holderName : ''} ${item.holderDetails ? `(${item.holderDetails})` : ''}` + result
        }
        if (item.position) {
          result = `${item.position}, ${result}`
        }
        if (result.length > 0) {
          result = ': ' + result
        }
        return `ИНН ${this.renderInnflHtml(item.inn)} ${result}`
      }
    }

  }

</script>




// WEBPACK FOOTER //
// HumanSelectorTab.vue?8c69e634